/**
 * @module LinkButton
 * @description
 */
import Link from 'next/link';
import { trackEvent } from '@/js/helpers/tracking';
import styles from './DynamicButton.module.css';

/**
 * @function LinkButton
 * @description
 */
export const LinkButton = ( { ...props } ) => {
  const {
    href = '#', children, position
  } = props;

  /**
   * @function handleClick
   * @description
   */
  const handleClick = ( event ) => {
    const { target } = event;
    const text = target.innerHTML;
    const data = {
      elementType: 'BUTTON',
      position,
      text,
      actionOutcome: 'INTERNALLINK'
    };

    trackEvent( { action: 'elementClicked', data, event } );
  };

  return (
    <Link
      href={ href }
      onClick={ handleClick }
      data-type="link"
      data-testid="link"
      className={ `btn ${ styles.component__btn }` }
      { ...props }>
      { children || 'Link Title' }
    </Link>
  );
};

export default LinkButton;
